import { Error } from '@mui/icons-material';
import { Alert } from 'components/Alert/Alert';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useNotificationSettings } from 'features/settings/hooks/useNotificationSettings';
import React, { useState } from 'react';

// TODO: Translation for error messsage is in https://wellframe.atlassian.net/browse/WFMOB-14580

export const NotificationErrorAlert = () => {
  const { isCreatedNotificationSettingsError, createNotificationErrorMessage } =
    useNotificationSettings();
  const { isMobile } = useDeviceType();

  const [isAlertOpen, setIsAlertOpen] = useState(isCreatedNotificationSettingsError);
  const handleAlertClose = () => {
    setIsAlertOpen(false);
  };

  return (
    <Alert
      isPresented={isAlertOpen}
      variant="filled"
      severity="error"
      message={createNotificationErrorMessage}
      anchorOrigin={{ vertical: isMobile ? 'bottom' : 'top', horizontal: 'center' }}
      icon={<Error />}
      snackbarSx={{ top: { sm: 80, md: 8 } }}
      handleDismiss={handleAlertClose}
    />
  );
};
